export const Segment = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M26 10H6" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M26 16H11.7143" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M26 22H11.7143" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
</svg>`;
